import functions from '../functions';
import lozad from 'lozad';

// [contact_form] shortcode (inc/contact-form.php). Grabs a reCAPTCHA
// Enterprise token on submit and posts straight to the opticache service at
// /services/contact/ - that endpoint runs the assessment and sends the mail.
//
// The Google Enterprise script is loaded lazily: prefetched via $.getScript
// once the form nears the viewport (same lozad pattern as images), with an
// on-submit load as the fallback if the user got there faster.
$(function () {
	const $form = $('.contact-form');
	const recaptchaKey = functions.getRecaptchaKey();

	if (! $form.length || ! recaptchaKey) {
		return;
	}

	let recaptchaPromise = null;

	function loadRecaptcha() {
		if (! recaptchaPromise) {
			recaptchaPromise = $.getScript(
				'https://www.google.com/recaptcha/enterprise.js?render=' + recaptchaKey
			);
		}
		return recaptchaPromise;
	}

	lozad('.load-recaptcha', {
		rootMargin: '200px 0px',
		loaded: loadRecaptcha,
	}).observe();

	$form.on('submit', function (e) {
		e.preventDefault();

		const form = this;

		if (! form.checkValidity()) {
			form.reportValidity();
			return;
		}

		$('.contact-btn').addClass('d-none');
		$('.contact-spinner').removeClass('d-none').addClass('d-flex');

		let params = functions.getFormData($(form));

		loadRecaptcha().then(function () {
			grecaptcha.enterprise.ready(function () {
				grecaptcha.enterprise.execute(recaptchaKey, { action: 'contact' }).then(function (token) {
					params['gRecaptchaToken'] = token;
					params['language'] = functions.getLang();
					params['recaptchaType'] = 'enterprise';
					params = functions.getDataForUrl(params);

					$.post('/services/contact/', params).then(response => {
						response = JSON.parse(response);

						$('#contact-modal').modal('show');
						$('.response-output').html(response.data);

						$('.contact-btn').removeClass('d-none');
						$('.contact-spinner').removeClass('d-flex').addClass('d-none');

						setTimeout(() => {
							$('#contact-modal').modal('hide');
							// details page's own contact modal, if this form is inside it
							$('#contactModal').modal('hide');
						}, 4000);

						if (response.status == true) {
							form.reset();
						}
					});
				});
			});
		});
	});
});
